import { render } from "./TopSearch.vue?vue&type=template&id=a3dc963e"
import script from "./TopSearch.vue?vue&type=script&lang=js"
export * from "./TopSearch.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__